import { render, staticRenderFns } from "./editCampaign.vue?vue&type=template&id=3569e16f&lang=pug"
import script from "./editCampaign.vue?vue&type=script&lang=js"
export * from "./editCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports